// extracted by mini-css-extract-plugin
export var actionsRow = "_1c-a";
export var actionsRowEnd = "_1c-b";
export var askRedoBlackBtn = "_1c-d";
export var askRedoBlackBtnIcon = "_1c-e";
export var exitModalActionBtn = "_1c-c";
export var exitModalRoot = "_1c-0";
export var followUpInput = "_1c-9";
export var modalContentBody = "_1c-7";
export var modalHeaderImage = "_1c-2";
export var modalImageLabel = "_1c-4";
export var modalImageOverlay = "_1c-3";
export var modalImageSubheading = "_1c-6";
export var modalImageTitle = "_1c-5";
export var modalImageWrapper = "_1c-1";
export var reasonCard = "_1c-f";
export var reasonCardSelected = "_1c-g";
export var reasonIcon = "_1c-j";
export var reasonIconWrap = "_1c-i";
export var reasonIndicator = "_1c-l";
export var reasonIndicatorDot = "_1c-n";
export var reasonIndicatorSelected = "_1c-m";
export var reasonLabel = "_1c-h";
export var reasonList = "_1c-8";
export var reasonTitle = "_1c-k";